var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = window.themeVariables.settings.moneyFormat;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
$(document).on('change', '[name="upsell_lock"]', function () {
  var otherChecked = $('.ah-other-required-insurance:checked').length;
  var requiredChecked = $('.ah-required-insurance:checked').length;
  var selectedVariants = [];
  var totalPrice = window.selected_variant.price;
  var totalComparePrice = window.selected_variant.compare_at_price;


  if (otherChecked > 0 && requiredChecked > 0) {
    $('.ah-incurance_product').removeClass('ah-disabled');
  } else {
    $('.ah-incurance_product').addClass('ah-disabled');
  }

  $('[name="upsell_lock"]:checked, .ah-includedd').each(function () {
    var variantId = $(this).val();
    var price = parseFloat($(this).attr('data-price')) || 0;
    var comparePrice = parseFloat($(this).attr('data-compare-price')) || 0;

    selectedVariants.push(variantId);
    totalPrice += price;
    totalComparePrice += comparePrice;
  });
  console.log('Selected Variant IDs:', selectedVariants);
   var formattedPrice = Shopify.formatMoney(totalPrice);
   var formattedComparePrice = Shopify.formatMoney(totalComparePrice);
  $('.popup-content price-list sale-price').text(formattedPrice);
  $('.popup-content price-list compare-at-price').text(formattedComparePrice);
});

// , .ah-included
$(document).on('change', '[name="upsell_lock"]', function () {
  var $hiddenContainer = $('.hidden-items');
  $hiddenContainer.empty(); 
  $('[name="upsell_lock"]:checked').each(function (index) {
    var variantId = $(this).val();
    var $input = $('<input>', {
      type: 'hidden',
      name: `items[${index+1}][id]`,
      value: variantId
    });
    $hiddenContainer.append($input);
  });
});
$(document).on('variant:change', '[is="product-form"]', function (e) {
  window.selected_variant = e.originalEvent.detail.variant;
  setTimeout(function(){
    $('[name="upsell_lock"]:eq(0)').trigger('change');
  },10)
});
$(document).on('submit', '[is="product-form"]', function (e) {
  setTimeout(function(){
    $('.popup-close').trigger('click')
  },1000)
});
$(function(){
  $('[name="upsell_lock"]:eq(0)').trigger('change');
  var $popup = $('#custom-section');
  var $body = $('body');

  function isOpen() {
    return $popup.hasClass('is-open') || $popup.css('display') === 'flex';
  }
  function openPopup() {
    $popup.addClass('is-open').css('display', 'flex');
    $body.addClass('popup-open'); // lock scroll
  }
  function closePopup() {
    $popup.removeClass('is-open').fadeOut('fast');
    $body.removeClass('popup-open'); // unlock scroll
  }

  // Open on button click (delegated in case button is rendered later)
  $(document).on('click', '.post-selection__atc-btn', function (e) {
    e.preventDefault();
    openPopup();
  });

  // Close on X button
  $(document).on('click', '.popup-close', function (e) {
    e.preventDefault();
    closePopup();
  });

  // Close on background click
  $popup.on('click', function (e) {
    if (e.target === this) closePopup();
  });

  // Close on Esc
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) closePopup();
  });
})